import React from 'react';
import { MultilineAddress } from '../../multiline-address';
const EcomAddress = props => {
  return /*#__PURE__*/React.createElement(MultilineAddress, props);
};
export default EcomAddress;
//# sourceMappingURL=ecom-address.js.map